import { analytics, logEvent } from "./config/firebase";

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import("web-vitals").then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const sendMetric = ({ name, delta, id }) => {
        if (analytics) {
          logEvent(analytics, "web_vital", {
            event_category: "Web Vitals",
            event_action: name,
            event_label: id,
            value: Math.round(name === "CLS" ? delta * 1000 : delta),
            non_interaction: true,
          });
        }
      };

      getCLS(sendMetric);
      getFID(sendMetric);
      getFCP(sendMetric);
      getLCP(sendMetric);
      getTTFB(sendMetric);
    });
  }
};

export default reportWebVitals;